import React from 'react'
import { FaCircleCheck } from "react-icons/fa6"
import { fontType, main } from '../../assets/extras'
import { getCurrentDate, compareDates, validateEmail, getAge, guessMonthNumb } from '../../assets/validator'
import { doc, getDoc, updateDoc } from 'firebase/firestore'
import { db } from '../../assets/connections'

const formatSubtitle = (dias_clase, id) => {
    if(id.split("-").length === 1 || id.split("-")[2] === "TEMP"){
        let dias = ""
        dias_clase.map(v => {
            let dia = ""
            const hora = v.de + "-" + v.a
            for(let i = 0; i < 3; i++){
                dia += v.dia[i]
            }

            if(dias == ""){
                dias = dia + " " + hora
            } else {
                dias += " / " + dia + " " + hora
            }

        })

        return dias
    } else {
        return ""
    }
}

const Player = ({v, navigate, reference, i, variables, setVariables, showMessage, validatePaymentDayColor, setTicket, infoSelect, academia, selectedSub, classes, navigation, selectedPlayers, setSelectedPlayers })=> {

    const updateSubscription = (field, value) => {
        const newSub = { ...v.suscripciones_jugador[0], [field]: value }

        setVariables(prev => {
            const newFiltered = [...prev.filteredPlayers]
            newFiltered[i] = { ...newFiltered[i], suscripciones_jugador: [newSub] }

            const newPlayers = [...prev.players]
            newPlayers[v.positionList] = {
                ...newPlayers[v.positionList],
                suscripciones_jugador: newPlayers[v.positionList].suscripciones_jugador.map(
                    (s, idx) => idx === v.positionSubscription ? newSub : s
                )
            }

            const newPlayersFiltered = prev.filtersApplied
                ? prev.playersFiltered.map(p => p.id === v.id ? { ...p, suscripciones_jugador: [newSub] } : p)
                : prev.playersFiltered

            return { ...prev, filteredPlayers: newFiltered, players: newPlayers, playersFiltered: newPlayersFiltered }
        })
    }

    return (
        <tr className='fila'>
            <td>
                <input
                    type="checkbox"
                    id="selectPlayer"
                    name="selectPlayer"
                    onChange={e => {
                        if(!selectedPlayers.includes(v.id)){
                            setSelectedPlayers(prev => [
                                ...prev, v.id
                            ])
                        } else {
                            setSelectedPlayers(prev => [
                                ...selectedPlayers.filter(id => id !== v.id)
                            ])
                        }
                    }}
                    checked={selectedPlayers.includes(v.id)}
                />
            </td>
            <th className='nombre' onClick={() => {
                navigate("/players/player", {
                    state: {
                        ref: reference,
                        id: v.id,
                        academia: academia
                    }
                })
            }}>{v.nombre_jugador}</th>
            {
                selectedSub != "Todos" && (
                    <th className='cantidad'>
                        <input
                            style={{
                                fontFamily: fontType.text
                            }}
                            className='info-cantidad'
                            type="number"
                            placeholder="$0"
                            value={v.suscripciones_jugador[0].por_pagar}
                            onChange={e => {
                                const t = e.target.value / 1

                                if (isNaN(t) || t === "") {
                                    showMessage("Debes ingresar una cantidad valida", "warning")
                                } else {

                                    updateSubscription("por_pagar", t)

                                }

                            }}
                        />
                    </th>
                )
            }
            {
                selectedSub != "Todos" && (
                    <th className='cantidad'>
                        <input
                            style={{
                                fontFamily: fontType.text,
                                borderColor: validatePaymentDayColor(v)
                            }}
                            className='info-cantidad'
                            type="number"
                            placeholder="$0"
                            value={v.suscripciones_jugador[0].pagado}
                            onChange={e => {
                                const t = e.target.value / 1

                                if (isNaN(t) || t === "") {
                                    showMessage("Debes ingresar una cantidad valida", "warning")
                                } else {

                                    updateSubscription("pagado", t)

                                }

                            }}
                        />
                    </th>
                )
            }
            {
                selectedSub != "Todos" && (
                    <th className='fecha'>
                        <input
                            className='input-fecha'
                            style={{
                                fontFamily: fontType.text
                            }}
                            value={null}
                            type='date'
                            onChange={e => {

                                if(selectedSub.fecha_pago == -2 || selectedSub.fecha_pago === -1){
                                    updateSubscription("fecha_pago", e.target.value)
                                } else {
                                    let newDate = getCurrentDate().split("-")
                                    newDate[2] = selectedSub.dia_pago.toString()
                                    newDate = newDate.join("-")

                                    if(compareDates(e.target.value, newDate) === 2 || compareDates(e.target.value, newDate) === 0){
                                        updateSubscription("fecha_pago", e.target.value)
                                    } else {
                                        showMessage("Debes seleccionar el dia " + selectedSub.dia_pago + " de " + guessMonthNumb(getCurrentDate().split("-")[1]) + " para registrar como pagado", "warning")
                                    }
                                }

                            }}
                        />
                        <p>{v.suscripciones_jugador[0].fecha_pago}</p>

                        <button className='btn-action' style={{
                            backgroundColor: main,
                            fontFamily: fontType.text
                        }} onClick={() => {
                            updateSubscription("fecha_pago", getCurrentDate())
                        }}>
                            HOY
                        </button>

                    </th>
                )
            }
            {
                selectedSub != "Todos" && (
                    <th className='cantidad' style={{
                        fontFamily: fontType.text,
                        padding: 5,
                        marginTop: 10,
                        borderRadius: 5,
                        borderWidth: 2,
                        borderColor: "#DDD",
                        borderStyle: "solid",
                        width: 250
                    }}>
                        <input
                            style={{
                                fontFamily: fontType.text,
                                maxWidth: "200px",
                                minWidth: "100px",
                                width: "100%"
                            }}
                            className='info-cantidad'
                            placeholder="..."
                            value={v.suscripciones_jugador[0].comentarios}
                            onChange={e => {
                                updateSubscription("comentarios", e.target.value)
                            }}
                        />
                        <button className='btn-action' style={{
                            backgroundColor: main,
                            fontFamily: fontType.title
                        }} onClick={async () => {
                            const newComment = variables.players[v.positionList].suscripciones_jugador[v.positionSubscription].comentarios

                            await getDoc(doc(doc(db, reference), "Jugador", v.correo_jugador)).then(r => {
                                const oldSus = r.data().suscripciones_jugador

                                for(let i = 0; i < oldSus.length; i++){
                                    if(oldSus[i].suscripcion === selectedSub.nombre_suscripcion){
                                        oldSus[i].comentarios = newComment
                                    }
                                }

                                setTimeout(() => {
                                    updateDoc(doc(doc(db, reference), "Jugador", v.correo_jugador), {
                                        suscripciones_jugador: oldSus
                                    }).then(r => {
                                        setTimeout(() => {
                                            showMessage("Comentario actualizado.", "success")
                                        }, 100)
                                    }).catch(e => {
                                        console.log(e.code + " " + e.message)
                                        setTimeout(() => {
                                            showMessage("Error al actualizar el comentario.", "error")
                                        }, 100)
                                    })
                                }, 100)
                            }).catch(e => {
                                console.log(e.code + " " + e.message)
                                        setTimeout(() => {
                                            showMessage("Error al obtener la informacionn del jugador.", "error")
                                        }, 100)
                            })
                        }}>
                            GUARDAR
                        </button>
                    </th>
                )
            }
            {
                infoSelect === "Clases" ?
                    <th className='extraInfo'>
                        {
                            v.clases_jugador.length === 0 ?
                                <p style={{
                                    fontFamily: fontType.title,
                                    fontSize: 20
                                }}>No hay clases</p>
                            :
                            v.clases_jugador.map(c => {
                                const clase = classes.filter(c2 => c2.id === c)[0]

                                if(clase != undefined){
                                    return (
                                        <p className='class' onClick={() => {
                                            navigation("/classes/class", {
                                                state: {
                                                    ref: reference,
                                                    id: clase.id,
                                                    academia: academia
                                                }
                                            })
                                        }}>{
                                            clase.nombre_clase
                                        } <br /> <span>{
                                            formatSubtitle(clase.dias_clase, clase.id)
                                        }</span></p>
                                    )
                                } else {
                                    return (
                                        null
                                    )
                                }
                            })
                        }
                    </th>
                :
                    <th className='extraInfo'>
                        <p>
                            {
                                infoSelect === "Asistencias" ?
                                    (v.asistencias || []).length
                                : infoSelect === "Categoria" ?
                                    v.categoria_jugador
                                : infoSelect === "Correo" ?
                                    validateEmail(v.id) ? v.id : "No hay un correo"
                                : infoSelect === "Telefono" ?
                                    v.telefono_jugador
                                : infoSelect === "Edad" ?
                                    v.edad_jugador ? getAge(v.edad_jugador) : "El jugador no tiene edad"
                                : infoSelect === "FechaAlta" ?
                                    v.fecha_alta ?
                                        v.fecha_alta
                                    : "No hay una fecha"
                                : infoSelect === "Rama" ?
                                    v.rama_jugador
                                : infoSelect === "Ranking" ?
                                    v.ranking_jugador
                                : "No se ha seleccionado una opcion"
                            }
                        </p>
                    </th>
            }
            {
                selectedSub != "Todos" && (
                    <th className='button'>
                        <FaCircleCheck size={30} color={main} onClick={() => {
                            if(v.suscripciones_jugador[0].fecha_pago === "----/--/--"){
                                showMessage("Debes seleccionar una fecha", "warning")
                            } else {
                                setTicket(prev => ({
                                    ...prev,
                                    show: true,
                                    data: variables.players[v.positionList],
                                    dataPayment: v
                                }))
                            }
                        }} />
                    </th>
                )
            }
        </tr>
    )
}

export default React.memo(Player)
